module.exports = __webpack_public_path__ + "img/btc.0c7af8a8.svg";